/**
 * Frontend faqat shu ikki sozlamani biladi. Backend manzili **hech qayerda**
 * qattiq yozilmaydi — u doim `VITE_API_BASE_URL` dan keladi, shuning uchun
 * bu papkani boshqa repoga ko'chirib, faqat `.env` ni almashtirish yetarli.
 */
export interface WebEnv {
  apiBaseUrl: string;
  mockMode: boolean;
}

/**
 * Xom env obyektini tekshirib, ilova ishlatadigan ko'rinishga keltiradi.
 * Sof funksiya — `import.meta` ga bog'lanmagan, shuning uchun testda ham,
 * kelajakda boshqa muhitda ham bir xil ishlaydi.
 */
export const readEnv = (raw: Record<string, string | undefined>): WebEnv => {
  const base = raw.VITE_API_BASE_URL;
  if (base === undefined || base.length === 0) {
    throw new Error("VITE_API_BASE_URL ko'rsatilmagan — .env faylini .env.example dan yarating");
  }
  return { apiBaseUrl: base.replace(/\/+$/, ''), mockMode: raw.VITE_MOCK === 'true' };
};

/** Vite tomonidan qurilish paytida o'rnatilgan env ni o'qiydi. */
export const getEnv = (): WebEnv =>
  readEnv(import.meta.env as unknown as Record<string, string | undefined>);
